import { ENABLE_UPDATED_FREE_SHIPPING_THRESHOLDS_UI_FOR_CART_241008 } from "@faire/web-api/indigofair/settings/ENABLE_UPDATED_FREE_SHIPPING_THRESHOLDS_UI_FOR_CART_241008";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

import { useSetting } from "./__internal__/useSetting";

export const getSettingUpdatedFreeShippingThresholdUI = () =>
  getSettingValueWithoutAssignment(
    ENABLE_UPDATED_FREE_SHIPPING_THRESHOLDS_UI_FOR_CART_241008,
    false
  );

export const useSettingUpdatedFreeShippingThresholdUI = () =>
  useSetting(ENABLE_UPDATED_FREE_SHIPPING_THRESHOLDS_UI_FOR_CART_241008, false);
